import scaleLogo_1 from "core/assets/images/base/170_mil.png";
import scaleLogo_2 from "core/assets/images/base/2_million.png";
import scaleLogo_3 from "core/assets/images/base/50_million.png";
import scaleLogo_4 from "core/assets/images/base/12x_growth.png";

const data = {
  Scale: [
    {
      title: "190 million+",
      description: "app downloads since 2015",
      image: [scaleLogo_1],
    },
    {
      title: "2 million+",
      description: "driver partners",
      image: [scaleLogo_2],
    },
    {
      title: "900,000+",
      description: "GoFood merchants",
      image: [scaleLogo_3],
    },
    {
      title: "2.448x",
      description: "jump in downloads from 2015 to 2020",
      image: [scaleLogo_4],
    },
  ],
  Section : {
    title: "3 countries. 20+ products. 1 leading on-demand platform.",
    video: "https://www.youtube.com/embed/VJH5FJ5kaJA?enablejsapi=1&amp;version=3&amp;controls=0&amp;rel=0&amp;autoplay=1&amp;loop=1&amp;mute=1&amp;playlist=VJH5FJ5kaJA&amp;playsinline=1"
  }
};

export default data;
